import React from 'react';
import {Popup, Card, Layout, Icon, Icons, Flex, Button, Goals} from 'components';
import {pluralize, modal, printSidebar, useDrop, useGrabbed, useList, openPopup, useNamedSelector, redirect} from 'helpers';
import {forbid} from 'store/session';
import {goals} from 'store';

export function Sidebar() {
  const projects = useNamedSelector('goals.projects');
  const permissions = useNamedSelector('permissions.list');
  const createNew = permissions.canAdd.goals ? modal(Goals.Projects.EditModal, { onSave: redirect }) : forbid;
  const [ list, Last ] = useList(projects);
  return (
    <Layout.Sidebar>
      <Flex middle className="secondary hidden-print">
        <h5 className="black pull-left">Projects</h5>
        <Icons.Print onClick={printSidebar} />
        <Icon name="plus-large" title="Add Goal" onClick={createNew} />
      </Flex>
      <Layout.Sidebar.Scrollable>
        { projects.map(project => <Project key={project.id} project={project} />)}
        <Last />
        { list.length == 0 &&
          <p className="text-center">Add goals that need to be accomplished. </p>
        }
        <p className="hidden-print">
          <Button icon="plus" className={['stretch', 'primary']} onClick={createNew}>
            New Project
          </Button>
        </p>
      </Layout.Sidebar.Scrollable>
    </Layout.Sidebar>
  );
}

const Project = ({project}) => {
  const grabbed = useGrabbed();
  return (
    <Card key={project.id} navLink={`/goals/projects/${project.id}/`} id={project.id} {...useDrop(goals.dispatch.attachToProject)}>
      <Popup.Menu.Handle Menu={Goals.Projects.Menu} project={project} />
      <Card.Body>
        <Card.Text>{ project.name }</Card.Text>
        { project.note &&
          <Card.Note>{ project.note }</Card.Note>
        }
        { project.goals &&
          <Card.Progress now={project.completed} max={project.goals.length}>
            { project.completed } / { project.goals.length } { pluralize('goal', project.goals.length) }
          </Card.Progress>
        }
      </Card.Body>
      { grabbed && grabbed.typeId !== project.id &&
        <Card.Dropzone>Drop here to attach to this project</Card.Dropzone>
      }
      <Card.Toolbar aria-haspopup="false">
        <Icon name="pencil" onClick={modal(Goals.Projects.EditModal, { project })} />
        <Icon name="trash" onClick={openPopup(Goals.Projects.RemoveMenu, {project})} />
      </Card.Toolbar>
    </Card>
  )
};
